// 通用工具:测距、测面、鼠标位置、添加百度街景图层、实时交通图层
import PanoComp from './PanoComponent';
import MeatureComp from './MeatureComponent';
import TrafficComp from './TrafficComponent';
const componentBase = (G as any).base.ComponentBase;
const component = componentBase.extend({
    // 属性
    options: {
        map: null,
        config: null,
        PanoComp: null,
        MeatureComp: null,
    },

    // 初始化
    initialize(options: any) {
        componentBase.prototype.initialize.call(this, options);
        // debugger
        this.options.PanoComp = new PanoComp(options);
        this.options.MeatureComp = new MeatureComp(options);
        this.options.TrafficComp = new TrafficComp(options);

        this._initMousePosition(this.map); // 获取鼠标位置
        this.currentLevel = this.getCurrentLevel();
    },
    //  销毁
    destroy() {
        componentBase.prototype.destroy.call(this);
        this.removeTrfficLayer();
    },

    load() {
        componentBase.prototype.load.call(this);
        //
        this.mousePosition.load();
    },

    addListeners() {
        //
        this.map.listen('resolutionchanged', this._onResolutionChanged, this);
    },

    removeListeners() {
        this.map.listen('resolutionchanged', this._onResolutionChanged, this);
    },

    unload() {
        this.mousePosition.unload();
        this.removeTrfficLayer(); // 移除实时交通图层
        componentBase.prototype.unload.call(this);
    },

    // 修改地图的宽高
    resize() {
        const mapId: string = this.map.options.targetId;
        const width = $('#' + mapId).width();
        const height = $('#' + mapId).height();
        this.map.setViewSize(width, height);
    },

    // 获取当前级别
    getCurrentLevel() {
        return Math.round(this.map.getZoomLevel());
    },

    /**
     * 添加百度全景图层与按钮到地图
     */
    addbdLayerCtol() {
        this.options.PanoComp.addbdLayerCtol();
    },

    /**
     * 添加腾讯全景图层与按钮到地图
     */
    addTencentLayerCtol() {
        this.options.PanoComp.addTencentLayerCtol();
    },

    /**
     * 移除百度街景覆盖范围图层与按钮
     */
    removebduLayerCtro() {
        this.options.PanoComp.removebduLayerCtro();
    },
    /**
     * 移除腾讯街景覆盖范围图层与按钮
     */
    removeTencentLayerCtro() {
        this.options.PanoComp.removeTencentLayerCtro();
    },

    /**
     * 移除实时交通图层
     */
    removeTrfficLayer() {
        this.options.TrafficComp.removeTrfficLayer();
    },

    /**
     * 添加实时交通图层
     */
    addTafficLayer() {
        this.options.TrafficComp.addTafficLayer();
    },

    getMousePositionComponent() {
        // 获得鼠标位置
        return this.mousePosition;
    },

    measureLength() {
        this.options.MeatureComp.measureLength();
    },

    measureArea() {
        // 面积面积
        this.options.MeatureComp.measureArea();
    },

    cancelMeasure() {
        // 取消测量
        this.options.MeatureComp.cancel();
    },

    clearMeasure() {
        this.options.MeatureComp.clear();
    },

    clearAll() {
        // 清屏
        this.map.clear({
            filterFn: (layer: any) => {
                return false;
            },
        });
    },
    /**
     * 截屏
     * @param domId {String} domid，默认为地图容器
     */
    screenShot(domId: any) {
        const screenShot = new G.common.ScreenShot({
            map: this.map,
        });
        screenShot.downloadImage(domId || null, '截屏');
    },
    /**
     * 获取屏幕截图
     * @param domId {String} domid，默认为地图容器
     */
    getScreenShot(domId: any) {
        const screenShot = new G.common.ScreenShot({
            map: this.map,
        });
        return screenShot.getImage(domId);
    },
    // 全图
    fullExtent() {
        this.map.fullExtent();
    },
    // 全屏
    fullScreen(domId: any) {
        const fullScreenComponent = this._getFullScreenComponent(domId);
        fullScreenComponent.fullScreen();
    },
    // 退出全屏
    exitFullScreen(domId: any) {
        const fullScreenComponent = this._getFullScreenComponent(domId);
        fullScreenComponent.exit();
    },
    //
    _getFullScreenComponent(domId: any) {
        if (!this.fullScreenComp) {
            this.fullScreenComp = new G.common.FullScreen({
                map: this.map,
                source: domId,
            });
        }
        return this.fullScreenComp;
    },

    _initMousePosition(map: any) {
        const mousePosition = new G.common.MousePosition({
            map,
            eventName: 'mousePosition',
            format: '{x}|{y}',
            precision: 6,
            formatType: '1', // 展示类型，1：带方向，如：E 117, N 43
            lnglatFormat: 'DD', // 坐标格式，DD：经纬度小数，DMS：度分秒
        });
        this.mousePosition = mousePosition;
    },
    // 分辨率变化
    _onResolutionChanged(event: any) {
        const level: number = Math.round(event.level);
        if (!(this.currentLevel === level)) {
            this.currentLevel = level;
            this.fire('levelChanged', {
                level,
            });
        }
    },
});

export default component;
